"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const moment_1 = __importDefault(require("moment"));
function default_1(errorCode) {
    const yymmdd = (0, moment_1.default)().format('YYMMDD');
    return `${i18next_1.default.t('화면을 캡쳐하여 1:1 문의하기 해주세요.')} ${errorCode ? `(접수 번호: ${yymmdd}${errorCode})` : ''}`;
}
exports.default = default_1;
